define('businessServices/authentication/accountPlanInfo',[
    'common/promises/promiseFactory', 'externalDependencies/clientWebSocket', 'constants/billingPackageTypeConstants'
], function() {
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    let _accountPlanWebSocket = clientWebSocket.forApplication("accountPlan");

    let _billingPackageTypes = require('constants/billingPackageTypeConstants');

    let data = {
        accountId: null
    };

    const ACTIVE_PLAN_VALUES = {
        hasTelephonyPackage: ko.observable(false),
        hasLiveReceptionistPackage: ko.observable(false),
        isLiveReceptionistOnboardingComplete: ko.observable(false),
        isLiveReceptionistOnboardingScheduled: ko.observable(false),
        isLiveReceptionistSignatureService: ko.observable(false),
        hasWebChatPackage: ko.observable(false),
        isWebChatOnboardingComplete: ko.observable(false),
        isWebChatOnboardingScheduled: ko.observable(false),
        hasOutboundCallingPackage: ko.observable(false),
        isOutboundCallingOnboardingComplete: ko.observable(false),
        isOutboundCallingOnboardingScheduled: ko.observable(false)
    };

    const hasTelephonyPackage = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.hasTelephonyPackage();
    });

    const hasLiveReceptionistPackage = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.hasLiveReceptionistPackage();
    });

    const isLiveReceptionistOnboardingComplete = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isLiveReceptionistOnboardingComplete();
    });

    const isLiveReceptionistOnboardingScheduled = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isLiveReceptionistOnboardingScheduled();
    });

    const isLiveReceptionistSignatureService = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isLiveReceptionistSignatureService();
    });

    const hasWebChatPackage = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.hasWebChatPackage();
    });

    const isWebChatOnboardingComplete = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isWebChatOnboardingComplete();
    });

    const isWebChatOnboardingScheduled = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isWebChatOnboardingScheduled();
    });

    const hasOutboundCallingPackage = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.hasOutboundCallingPackage();
    });

    const isOutboundCallingOnboardingComplete = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isOutboundCallingOnboardingComplete();
    });

    const isOutboundCallingOnboardingScheduled = ko.pureComputed(() => {
        return ACTIVE_PLAN_VALUES.isOutboundCallingOnboardingScheduled();
    });

    const getById = (id) => {
        switch (id) {
            case _billingPackageTypes.telephony.id:
                return hasTelephonyPackage();
            case _billingPackageTypes.liveReceptionist.id:
                return hasLiveReceptionistPackage();
            case _billingPackageTypes.webChat.id:
                return hasWebChatPackage();
            case _billingPackageTypes.outboundCalling.id:
                return hasOutboundCallingPackage();
            default:
                return true;
        }
    };

    const receiveAlertLoginSuccessful = (loginInfo) => {
        data.accountId = loginInfo.accountId;
        getAccountPlan();
    };

    const receiveAlertLogout = () => {
        data.accountId = null;
        _accountPlanWebSocket.disposeOfEvents();
    };

    const getAccountPlan = () => {
        return _promiseFactory.defer((promise) => {

            _accountPlanWebSocket.send("getAccountPlan", { accountId: data.accountId }, (response, errMsg) => {
                if (errMsg) {
                    throw new Error(errMsg);
                }
                updatePlansList(response);
                promise.resolve();
            });
        });
    };

    const setOnboardingScheduled = () => {
        return _promiseFactory.defer((promise) => {

            _accountPlanWebSocket.send("setOnboardingScheduled", {}, (response, errMsg) => {
                if (errMsg) {
                    throw new Error(errMsg);
                }

                if (response !== null) {
                    ACTIVE_PLAN_VALUES.isLiveReceptionistOnboardingScheduled(response.isLiveReceptionistOnboardingScheduled || false);
                    ACTIVE_PLAN_VALUES.isWebChatOnboardingScheduled(response.isWebChatOnboardingScheduled || false);
                    ACTIVE_PLAN_VALUES.isOutboundCallingOnboardingScheduled(response.isOutboundCallingOnboardingScheduled || false);
                }

                promise.resolve();
            });
        });
    };

    const onAccountPlanUpdate = () => {
        _accountPlanWebSocket.subscribeToEvent("accountPlanChanged", (response, errMsg) => {
            if (errMsg) {
                throw new Error(errMsg);
            }
            updatePlansList(response);
        });
    };

    const updatePlansList = (response) => {
        if (response !== null) {
            ACTIVE_PLAN_VALUES.hasTelephonyPackage(response.telephonyPackage !== null);
            ACTIVE_PLAN_VALUES.hasLiveReceptionistPackage(response.liveReceptionistPackage !== null);
            ACTIVE_PLAN_VALUES.isLiveReceptionistOnboardingComplete(response.isLiveReceptionistOnboardingComplete || false);
            ACTIVE_PLAN_VALUES.isLiveReceptionistOnboardingScheduled(response.isLiveReceptionistOnboardingScheduled || false);
            ACTIVE_PLAN_VALUES.isLiveReceptionistSignatureService(response.isLiveReceptionistSignatureService || false);
            ACTIVE_PLAN_VALUES.hasWebChatPackage(response.webChatPackage !== null);
            ACTIVE_PLAN_VALUES.isWebChatOnboardingComplete(response.isWebChatOnboardingComplete || false);
            ACTIVE_PLAN_VALUES.isWebChatOnboardingScheduled(response.isWebChatOnboardingScheduled || false);
            ACTIVE_PLAN_VALUES.hasOutboundCallingPackage(response.outboundCallingPackage !== null);
            ACTIVE_PLAN_VALUES.isOutboundCallingOnboardingComplete(response.isOutboundCallingOnboardingComplete || false);
            ACTIVE_PLAN_VALUES.isOutboundCallingOnboardingScheduled(response.isOutboundCallingOnboardingScheduled || false);
        } else {
            Object.keys(ACTIVE_PLAN_VALUES).forEach((plan) => {
                ACTIVE_PLAN_VALUES[plan](false);
            });
        }
    };

    onAccountPlanUpdate();

    return {
        hasTelephonyPackage : hasTelephonyPackage,
        hasLiveReceptionistPackage : hasLiveReceptionistPackage,
        isLiveReceptionistOnboardingComplete : isLiveReceptionistOnboardingComplete,
        isLiveReceptionistOnboardingScheduled : isLiveReceptionistOnboardingScheduled,
        isLiveReceptionistSignatureService: isLiveReceptionistSignatureService,
        hasWebChatPackage : hasWebChatPackage,
        isWebChatOnboardingComplete : isWebChatOnboardingComplete,
        isWebChatOnboardingScheduled : isWebChatOnboardingScheduled,
        hasOutboundCallingPackage : hasOutboundCallingPackage,
        isOutboundCallingOnboardingComplete : isOutboundCallingOnboardingComplete,
        isOutboundCallingOnboardingScheduled : isOutboundCallingOnboardingScheduled,
        getById: getById,
        setOnboardingScheduled: setOnboardingScheduled,

        alerts : {
            receiveAlertLoginSuccessful : receiveAlertLoginSuccessful,
            receiveAlertLogout : receiveAlertLogout
        }
    };
});

